export default "__VITE_ASSET__BmS6596W__"